import { useEffect, useState } from "react";

/**
 * Gets width for referenced element, recalculates after page resize.
 *
 * @param {*} ref Element reference.
 *
 * @returns {number} Element width.
 */
export const useContainerWidth = (ref) => {
    const [width, setWidth] = useState(false);

    useEffect(() => {
        let recalcWidth = () => {
            let w = ref?.current?.offsetWidth || 0;
            setWidth(w);
        };

        // Recalculate on window resize.
        window?.addEventListener("resize", recalcWidth);

        // on initial load, run the callback once
        recalcWidth();

        return () => {
            window.removeEventListener("resize", recalcWidth);
        };
    }, [ref]);

    return width ? width : 0;
};
